<template>
  <f7-page
    @page:init="onPageInit"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore"
  >
    <f7-navbar :back-link="$t('back')">
      <f7-nav-title>{{ $t("balance") }}</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-list
      media-list
      virtual-list
      :virtual-list-params="{
        height: theme.ios ? 63 : theme.md ? 73 : 77,
      }"
    >
      <template v-for="(item, index) in list" :key="index">
        <f7-list-item
          :title="$t('CashFlowType.' + item.Type)"
          :header="'Time：' + formatDate(item.DateTime)"
          :footer="item.Remark"
          class="shang"
          ><template #after
            ><span :class="item.Amount > 0 ? 'text_red' : 'text_green'">{{
              item.Amount
            }}</span></template
          ><template #subtitle
            ><span class="text_teal">{{ item.Value }}</span></template
          ></f7-list-item
        >
      </template>
    </f7-list>
  </f7-page>
</template>
<script>
import util from "util/date";
import { getCashFlowList } from "@/api/api";
import { theme, f7 } from "framework7-vue";

export default {
  props: {
    f7route: Object,
  },
  data() {
    return {
      theme,
      allowInfinite: true,
      showPreloader: false,
      list: [],
      total: 0,
      page: 1,
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      self.showPreloader = true;
      self.getList();
    },
    //获取列表
    getList(isload = false) {
      const self = this;
      if (isload) {
        f7.preloader.show();
        self.page = 1;
        self.list = [];
      }
      let para = {
        page: this.page,
        key: window.localStorage.Shop_Id,
      };
      getCashFlowList(para).then((res) => {
        self.list = this.list.concat(res.data.response.data);
        f7.preloader.hide();
        self.showPreloader = false;
        if (res.data.response.data.length > 0) {
          self.page++;
          self.allowInfinite = true;
        }
      });
    },
    onPageInit() {
      this.getList(true);
    },
  },
};
</script>